import { QueryClient } from '@tanstack/react-query';
import { createAppQueryCache } from '@/services/query-error-handler';

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
    queryCache: createAppQueryCache(),
  });
}

export const queryClient = createAppQueryClient();
